import { requireNonNullable } from '@disy/lib/custom-error';

import type { DatasetKey } from 'cadenza/api-client/self-service-api';
import { postEvent } from 'cadenza/integration/post-message';
import type { EditGeometryDialog } from 'cadenza/workbook/edit-geometry-dialog/edit-geometry-dialog';

export function isEditGeometryDialogOpen() {
  return Boolean(document.querySelector('.d-edit-geometry-dialog'));
}

export function getEditGeometryDialog() {
  return requireNonNullable(document.querySelector<EditGeometryDialog>('.d-edit-geometry-dialog'));
}

export function dispatchGeometryDeleteEvent(datasetKeys: DatasetKey[]) {
  postEvent('editGeometry:delete', {
    objectIds: datasetKeys.map((datasetKey) => Object.values(datasetKey)),
  });
}
